import styled from "styled-components";

export const FaqsCont = styled.div `
    padding:2rem ;
    width:80% ;
    align-self:center ;
    @media only screen and (max-width: 768px) {
        padding:0.8rem ;
        width:100% ;
        align-self:center ;
    }
`